import { createContext, useContext, useEffect, useState } from "react";
import { authLogin, authLogout, authMe } from "./api";

// FastAPI 422 responses return an array of error objects, not a string —
// rendering that array crashes React, so normalize it first.
export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

const AuthContext = createContext(null);

// user: null = still checking, false = logged out, object = logged in
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    authMe().then(setUser).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const u = await authLogin(email, password);
    setUser(u);
  };

  const clearAuth = () => {
    setUser(false);
  };

  const logout = async ({ remote = true } = {}) => {
    if (remote) {
      await authLogout().catch(() => {});
    }
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, clearAuth }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
